<script setup lang="ts">
defineProps<{
  message?: string
}>()

defineEmits<{
  retry: []
}>()
</script>

<template>
  <div class="error-state" role="alert">
    <p class="error-state__message">
      {{ message ?? 'Der opstod en fejl. Prøv igen senere.' }}
    </p>
    <button class="error-state__retry" type="button" @click="$emit('retry')">Prøv igen</button>
  </div>
</template>

<style lang="scss" scoped>
.error-state {
  display: flex;
  flex-direction: column;
  gap: space(3);
  align-items: center;
  padding: space(6);
  background: color('red-100');
  border: 1px solid color('error');
  border-radius: $radius-md;
  text-align: center;

  &__message {
    margin: 0;
    color: color('ink');
    font-weight: $font-weight-medium;
  }

  &__retry {
    padding: space(2) space(5);
    background: color('error');
    border: none;
    border-radius: $radius-md;
    color: color('white');
    font-weight: $font-weight-semibold;
    min-height: 44px;
    cursor: pointer;
    transition: filter $duration-base $easing-standard;

    &:hover {
      filter: brightness(0.9);
    }

    &:focus-visible {
      outline: 2px solid color('ink');
      outline-offset: 2px;
    }
  }
}
</style>
